import React from 'react';
import { InputGroup as ChakraInputGroup, InputGroupProps as ChakraInputGroupProps } from '@chakra-ui/react';

export function InputGroup(props: ChakraInputGroupProps) {
  return <ChakraInputGroup {...props} />;
}
